export default __webpack_public_path__ + "static/media/Panetela.38697fa2.jpg";